module.exports = __webpack_public_path__ + "static/media/thumbnail.a01e0ed6.jpg";